import gql from 'graphql-tag';

export const ADDRESS_VIEW_MODEL_FRAGMENT = gql`
  fragment AddressFields on AddressViewModel {
    id
    city
    address
    country
    postalCode
    stateProvince
  }
`;
